var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"pa-0"},[_c('v-row',[_c('v-col',{staticClass:"py-0"},[_c('h1',{staticClass:"font-weight-bold my-1 my-sm-2 my-md-4 my-lg-8 text-h2 text-md-h1"},[_vm._v("\n\t\t\t\t"+_vm._s(_vm.greeting.heading)+"\n\t\t\t")])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }